export function largeNumberFormatter(value: number | string) {
    if (value === "") {
        return value;
    }

    const intValue = typeof value === "string" ? parseInt(value, 10) : value;

    const formatter = new Intl.NumberFormat("nb", {
        maximumFractionDigits: 0,
    });

    return formatter.format(intValue);
}
